import styled from 'styled-components';

import { Button as DefaultButton } from '@simplywallst/ui-core';

export const IconWrapper = styled('div')`
  position: relative;
  left: 0;
  padding: ${({ theme }) => theme.x1spacePx / 2}px;
  > svg {
    position: absolute;
    top: -2px;
    left: 0;
  }
`;

export const IconWrapperRisks = styled(IconWrapper)`
  &:before {
    content: '';
    display: block;
    background-color: ${({ theme }) => theme.color.white};
    border-radius: ${({ theme }) => theme.x3spacePx}px;
    width: 12px;
    height: 12px;
    margin: 0;
  }
`;

export const Button = styled(DefaultButton)`
  box-shadow: none;
  > svg {
    margin-right: -${({ theme }) => theme.x1spacePx}px;
  }
  &:hover {
    > svg {
      transform: rotate(90deg);
    }
  }
`;
